<template>
  <card v-bind:class="{unread: hasntRead}">
    <div class="row">
      <div class="col-10">
        <h4 class="card-title">Ticket #{{ticket['ticket_id']}}</h4>
      </div>
      <div class="col-2">
        <base-button v-if="ticket['is_delete'] === '0'" :disabled="!getRules" type="danger" size="sm" icon style="margin-left: -6px" @click="deleteTicket">
          <i class="tim-icons icon-trash-simple"></i>
        </base-button>
        <base-button v-else type="info" size="sm" icon :disabled="!getRules" style="margin-left: -6px" @click="restoreTicket">
          <i class="tim-icons icon-refresh-01"></i>
        </base-button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <h6 class="card-subtitle mb-2 text-muted">FROM: {{employee}}</h6>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12" v-bind:class="getStyle" >
        <code style="font-size: 14px;color: white;" class="card-text" >Final date: {{getDate}}</code>
      </div>
    </div>
    <div class="row" style="margin-top: 15px; margin-bottom: 15px">
      <div class="col-md-12">
        <code class="card-text" style="font-size: 16px; font-family: Noto Sans, sans-serif"><b>{{ticket.title}}</b></code>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <base-button class="clock-button" simple block type="warning" @click="open">
          Open ticket
        </base-button>
      </div>
      <div class="col-md-6" v-if="!getDone">
        <base-button class="clock-button" simple block type="success" @click="done">
          Complete
        </base-button>
      </div>
      <div class="col-md-6" v-else-if="getReady">
        <base-button class="clock-button" simple block type="info" @click="confirm">
          Confirm
        </base-button>
      </div>
      <div class="col-md-6" v-else>
        <base-button class="clock-button" simple block disabled type="info">
          Confirm
        </base-button>
      </div>
    </div>
  </card>
</template>

<script>

    export default {
      name: "TicketCard",
      props: ['ticket', 'employee', 'employee_id'],
      methods:{
        open(){
          this.$router.push('/ticket-details/?ticket-id=' + this.ticket['ticket_id']);
        },
        done(){
          const action = "completed";
          const today = new Date();
          const data = {
            ticket_id : this.ticket['ticket_id'],
            is_done : "1",
            is_read_to : "1",
            is_read_from : "0",
            ending_date : today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate(),
          };
          this.$emit("update", data, action);
        },
        confirm(){
          const action = "confirmed";
          const data = {
            ticket_id : this.ticket['ticket_id'],
            is_confirm : "1",
            is_read_from : "1",
          };
          this.$emit("update", data, action);
        },
        deleteTicket(){
          const action = "deleted";
          const data = {
            ticket_id : this.ticket['ticket_id'],
            is_delete : "1",
          };
          this.$emit("update", data, action);
        },
        restoreTicket(){
          const action = "restored";
          const data = {
            ticket_id : this.ticket['ticket_id'],
            is_delete : "0",
          };
          this.$emit("update", data, action);
        },
      },
      computed:{
        getReady(){
          return (this.ticket["is_confirm"] === "0" && this.getRules)
        },
        getDone(){
          return this.ticket["is_done"] === "1"
        },
        getRules(){
          return (this.ticket["employee_id_from"] === this.employee_id);
        },
        hasntRead(){
          if (this.employee_id === this.ticket["employee_id_from"] && this.ticket['is_read_from'] === "0"){return true;}
          else return this.employee_id === this.ticket["employee_id_to"] && this.ticket['is_read_to'] === "0";
        },
        getDate(){
          if (this.ticket['done_before'] == null){
            return "not selected";
          }
          else{
            return new Date(this.ticket['done_before'].split('-').join('/')).toLocaleDateString()
          }
        },
        getStyle(){
          let status = {};
          if (this.ticket['is_done'] === "1"){
            status['default'] = true;
            return status;
          }
          if (this.ticket['done_before'] === null){
            status[this.ticket['priority']] = true;
            return status;
          }
          const today = new Date();
          const doneBefore = new Date(this.ticket['done_before'].split('-').join('/'));
          const diffTime = doneBefore - today;
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          if (diffDays < 0){
            status['danger'] = true;
            return status;
          }
          else if (diffDays < 1){
            status['warning'] = true;
            return status;
          }
          else{
            status[this.ticket['priority']] = true;
            return status;
          }
        },
      }
    }
</script>

<style scoped>
  .card{
    min-width: 18rem;
  }
  .unread{
    border: dotted #9d2fff;
  }
  .danger{
    background: #f5365c;
  }
  .warning{
    background: #f96332;
  }
  .normal{
    background: #40b27e;
  }
  .not-important{
    background:#3b5998;
  }
  .default{

  }
</style>
